import type Guid from "@/app/types/common/guid";
import type { InjectionKey } from "vue";

export interface Validator {
  validate(): boolean;
  reset(): void;
  resetValidation(): void;
}

export const registerValidatorKey: InjectionKey<
  (id: Guid, validator: Validator) => void
> = Symbol();

export const unregisterValidatorKey: InjectionKey<(id: Guid) => void> =
  Symbol();
